<div class="confirmation-question">
  @if (isEditing()) {
    <div class="question-config">
      <label class="config-label">
        @if (getQuestionTypeIcon(); as iconInfo) {
          <span class="question-type-icon-wrapper">
            @if (iconInfo.iconType === 'prime') {
              <i [class]="'pi ' + iconInfo.icon" class="question-type-icon"></i>
            }
            @if (iconInfo.iconType === 'material') {
              <span class="material-symbols-outlined question-type-icon">{{ iconInfo.icon }}</span>
            }
          </span>
        }
        Statement to confirm
      </label>
      <!-- A textarea, not an input: declarations run to several lines. -->
      <textarea
        #labelInput
        class="config-input statement-input"
        rows="3"
        [value]="question().labelText"
        (input)="onStatementChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="e.g. I confirm that I hold a valid passport for the duration of the programme"></textarea>

      <label class="config-label">Additional Info</label>
      <input
        type="text"
        class="config-input"
        [value]="question().additionalInfo ?? ''"
        (input)="onAdditionalInfoChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter additional information">

      <label class="config-label">Helper Text</label>
      <input
        type="text"
        class="config-input"
        [value]="question().helperText ?? ''"
        (input)="onHelperTextChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter helper text">

      <div class="required-toggle-row">
        <label class="config-label">
          <span class="required-asterisk">*</span>
          Required
        </label>
        <label class="required-toggle-switch">
          <input
            type="checkbox"
            [checked]="question().isRequired"
            (change)="onRequiredToggle()"
            [disabled]="disabled()">
          <span class="toggle-slider"></span>
        </label>
      </div>
    </div>
  } @else {
    <div class="question-preview">
      <!-- The checkbox and the statement read as one line, which is the point
           of the type: the label is what is being agreed to. -->
      <label class="confirmation-row">
        <input
          type="checkbox"
          class="confirmation-checkbox"
          [disabled]="disabled()">
        <span class="confirmation-statement">
          <span [innerHTML]="sanitizeHtml(question().labelText || 'Confirm this statement')"></span>
          @if (question().isRequired) {
            <span class="required-indicator">*</span>
          }
        </span>
      </label>
      @if (question().additionalInfo) {
        <span class="additional-info" [innerHTML]="sanitizeHtml(question().additionalInfo)"></span>
      }
      @if (question().helperText) {
        <span class="helper-text">{{ question().helperText }}</span>
      }
    </div>
  }
</div>
